import { z } from "zod";
import startTreezorKycLiveness from "./startTreezorKycLiveness.js";

export default {
  params: z.object({
    memberInvitationId: z.string(),
  }),
  response: startTreezorKycLiveness.response,
};
